import React from 'react'

export const OrderTypeField = ({ record = {} }) => {
  const text = record.type?.toLowerCase() === 'regular' ? 'Material' : 'Return';
  return <span>{text}</span>;
}
